import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Chart from "react-apexcharts";
import Config from "../Config";
import { useAuthHandling } from '../useAuthhandling';


function Profuserpie({dashboarddata}) {
  const [customerdata, setCustomer] = useState([]);
  const [customercount, setCustcount] = useState([]);
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

 

  const [options, setOptions] = useState({
    labels: ["Professional", "User"],
    colors: ["#7272f3", "#4793c1"],

    fill: {
      colors: ["#7272f3", "#4793c1"],
    },
    stroke: {
      colors: ["#7272f3", "#4793c1"],
    },
    markers: {
      colors: ["#7272f3", "#4793c1"],
    },
    title: {
      text: "No of Pofessionals vs Users",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: undefined,
        color: "#fff",
        marginTop: "12px",
      },
    },
  });

  
  return (
    <div className="profuserpie">
      <Chart
        options={options}
        series={[dashboarddata.totalProfessionalUsers, dashboarddata.totalNormalUsers]}
        type="donut"
        width="100%"
        height="300px"
        color="white"
      />
    </div>
  );
}

export default Profuserpie;
